import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ScrollText, ChevronRight, FileText, Library, FileCheck2, FileStack, BookMarked, Map, Sparkles } from 'lucide-react';
import { Card } from '../components/ui/card';
import { boardSubjects, boardResources, sampleNotes } from '../mock';
import { FeatureTile } from '../components/FeatureTile';
const iconMap = { FileText, Library, FileCheck2, FileStack, BookMarked, Map };

export default function BoardExamPage() {
  return (
    <div className="px-4 pt-4 space-y-5">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium">
        <ArrowLeft size={16} /> ମୁଖ୍ୟ ପେଜ କୁ ଫେରନ୍ତୁ
      </Link>

      {/* Hero */}
      <div className="relative overflow-hidden rounded-3xl p-5 text-white shadow-lg"
           style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #2563eb 50%, #0891b2 100%)' }}>
        <div className="absolute -top-8 -right-8 opacity-20"><ScrollText size={110} /></div>
        <ScrollText size={26} />
        <h1 className="text-xl font-extrabold mt-2">ଦଶମ ଶ୍ରେଣୀ ବୋର୍ଡ ପରୀକ୍ଷା</h1>
        <p className="text-xs text-white/90 font-medium">BSE Odisha — Class 10 Board Exam</p>
        <p className="text-[11px] text-white/85 mt-1">ସମସ୍ତ ବିଷୟ — ପାଠ୍ୟ ନୋଟ୍ସ, ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ, ମଡେଲ୍ ପେପର</p>
      </div>

      {/* Subjects */}
      <div>
        <h3 className="text-base font-extrabold text-gray-900">ବିଷୟ · Subjects</h3>
        <div className="grid grid-cols-2 gap-3 mt-3">
          {boardSubjects.map((s) => {
            const n = (sampleNotes.board || []).filter((x) => x.subjectKey === s.id).length;
            return (
            <Link key={s.id} to={`/notes/board?subject=${s.id}`} data-testid={`board-subject-${s.id}`}
              className={`relative overflow-hidden rounded-2xl p-4 text-white shadow-md bg-gradient-to-br ${s.color} min-h-[125px] flex flex-col justify-between hover:scale-[1.03] active:scale-[0.98] transition-transform cursor-pointer`}>
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-white/10 rounded-full blur-xl" />
              <div className="relative flex items-center gap-2">
                <span className="text-2xl">{s.icon}</span>
              </div>
              <div className="relative">
                <div className="font-bold text-sm leading-tight">{s.name}</div>
                <div className="text-[10px] text-white/85">{s.nameEn}</div>
                <div className="text-[10px] text-white/95 font-semibold mt-1">{n > 0 ? `${n} ଅଧ୍ୟାୟ ଉପଲବ୍ଧ →` : 'ନୋଟ୍ସ ଶୀଘ୍ର ଆସୁଛି'}</div>
              </div>
            </Link>
            );
          })}
        </div>
      </div>

      {/* Resources */}
      <div>
        <h3 className="text-base font-extrabold text-gray-900 flex items-center gap-1.5">
          <Sparkles size={15} className="text-indigo-500" /> ଅଧ୍ୟୟନ ସଂପଦ · Resources
        </h3>
        <div className="grid grid-cols-2 gap-3 mt-3">
          {boardResources.map((r, i) => (
            <FeatureTile key={i} item={r} icon={iconMap[r.icon] || FileText} gradient={r.color} testId={`board-tile-${i}`} />
          ))}
        </div>
      </div>

      {/* Exam Info Card */}
      <Card className="rounded-2xl p-4 border-gray-200">
        <h4 className="font-bold text-gray-900">ପରୀକ୍ଷା ବିବରଣୀ · Exam Details</h4>
        <div className="grid grid-cols-2 gap-3 mt-3">
          <div className="p-3 rounded-xl bg-indigo-50">
            <div className="text-[10px] font-semibold text-indigo-700">ଆୟୋଜକ</div>
            <div className="text-sm font-bold text-gray-900 mt-1">BSE Odisha</div>
          </div>
          <div className="p-3 rounded-xl bg-blue-50">
            <div className="text-[10px] font-semibold text-blue-700">ପୁର୍ଣ ମାର୍କ</div>
            <div className="text-sm font-bold text-gray-900 mt-1">600 (100 × 6)</div>
          </div>
          <div className="p-3 rounded-xl bg-cyan-50">
            <div className="text-[10px] font-semibold text-cyan-700">ପାସ ମାର୍କ</div>
            <div className="text-sm font-bold text-gray-900 mt-1">33%</div>
          </div>
          <div className="p-3 rounded-xl bg-teal-50">
            <div className="text-[10px] font-semibold text-teal-700">ସମୟ</div>
            <div className="text-sm font-bold text-gray-900 mt-1">3 ଘଣ୍ଟା</div>
          </div>
        </div>
      </Card>
    </div>
  );
}
